import script from "./JsjOrderJj.vue?vue&type=script&setup=true&lang=js"
export * from "./JsjOrderJj.vue?vue&type=script&setup=true&lang=js"

import "./JsjOrderJj.vue?vue&type=style&index=0&id=0381d9f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0381d9f2"]])

export default __exports__